export const employmentContract = {
  // Page
  CREATE_EMPLOYMENT_CONTRACT: 'Create Employment Contract',
  SIGNATURES: 'Signatures',

  // Employer Information section
  EMPLOYER_INFORMATION: 'Employer Information',
  EMPLOYEE_INFORMATION: 'Employee Information',
  COMPANY: 'Company',
  ORGANISATION_NUMBER: 'Organisation Number',
  ADDRESS: 'Address',
  ZIP_CODE: 'ZIP Code',
  COUNTRY: 'Country',
  PHONE_NUMBER: 'Phone Number',

  // Employee Information section
  FULL_NAME: 'Full Name',
  SOCIAL_SECURITY_NUMBER: 'Social Security Number',
  EMAIL: 'Email',
  CITY: 'City',
  POSTAL_CODE: 'Postal Code',
  ACCOUNT_SETTINGS: 'Account Settings',

  // Signature sections
  ON_BEHALF_OF_EMPLOYER: 'On behalf of the Employee:',
  ON_BEHALF_OF_INVOZIO: 'On behalf of Invozio LV SIA:',
  DATE: 'Date',
  PLACE: 'Place',
  SIGNATURE: 'Signature',
  DRAW_SIGNATURE: 'Draw Signature',
  UPLOAD_SIGNATURE: 'Upload Signature',
  CLICK_DRAW_TO_SIGN: 'Click "Draw Signature" to sign here',
  EC_SIGNATURE_UPLOAD_INFO: 'Draw your signature in the box, or upload one as a PNG or JPG image (max 1 MB).',
  EC_ERROR_SIGNATURE_FORMAT: 'Signature image must be a PNG or JPEG file. Please convert the photo before uploading.',
  CLEAR: 'Clear',
  NAME_CLARIFICATION: 'Name Clarification',
  ENTER_NAME_CLARIFICATION: 'Enter name clarification...',
  INVOZIO_SIGNER_TITLE: 'HR-chef',
  DIGITALLY_PRE_SIGNED: 'Digitally pre-signed',
  NO_SIGNATURE_YET: 'No signature provided yet',

  // Footer
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',

  // Validation
  EC_VALIDATION_DATE_REQUIRED: 'Date is required',
  EC_VALIDATION_SIGNATURE_REQUIRED: 'Signature is required',
  EC_VALIDATION_NAME_CLARIFICATION_REQUIRED: 'Name clarification is required',
  CONTRACT_SUBMITTED_SUCCESS: 'Employment contract submitted successfully!',
  DOWNLOAD_EMPLOYMENT_CONTRACT: 'Download Employment Contract',
};
